import { render, staticRenderFns } from "./BreadcrumbParents.vue?vue&type=template&id=1517afd7&scoped=true"
import script from "./BreadcrumbParents.vue?vue&type=script&lang=js"
export * from "./BreadcrumbParents.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbParents.vue?vue&type=style&index=0&id=1517afd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1517afd7",
  null
  
)

export default component.exports